import ClientCard from '@feat-clients/card/ClientCard';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

/**
 * `/dashboard/doctor/patients/:id/card` — one patient's record, as a doctor reads it.
 *
 * The SAME ClientCard the office uses, on the `doctor` audience. Not a
 * doctor-flavoured copy: a second card would drift from this one the first time
 * either was touched, and the doctor would slowly be looking at a different
 * record of the same patient.
 *
 * What the audience changes is what a clinical reader has any business with —
 * no billing, no caregiver-notes stream, no edit action pointing at a staff form
 * the doctor's route tree does not contain. Rows are the policies' call either
 * way: `clients_select_policy` narrows a doctor to their own patients, so a
 * hand-typed id for someone else's patient finds nothing.
 */
export const DoctorPatientCardPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const clientId = Number(id);

  // Same guard as the staff page: a non-numeric id can only come from a
  // hand-edited URL, and fetching with NaN would 422 several times over.
  if (!Number.isFinite(clientId) || clientId <= 0) {
    return <Alert type="error" showIcon message={t('client-card-invalid-id')} />;
  }

  return <ClientCard clientId={clientId} audience="doctor" />;
};

export default DoctorPatientCardPage;
